import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';

const GinBrowseIssuesRedirect = (): React.JSX.Element => {
	const [{ match }] = useRouter();

	const issueKey = match.params.issueKey ?? '';

	return <ScreenRedirect to={`/issues/${issueKey}`} />;
};

export default GinBrowseIssuesRedirect;
